import React from 'react';
import logo from '../../Img/Gmc_Blanc.svg';
import { obtenirNumeroServeur } from '../../App_Code/Utils';

const Maintenance = () => {
    /* 'fixed-nav' réserve la place au header, ce qui laisse une zone blanche disgracieuse
        Suppression de la classe du body de façon temporaire */
    document.body.classList.remove('fixed-nav');

    return (
        <div className="y100 center full-bg-danger">
            <div className="">
                <img
                    className="logo mb-3"
                    src={logo}
                    alt="Gérer ma copro"
                    aria-label={obtenirNumeroServeur()}
                    aria-hidden="true"
                />
                <p className="text-light font-weight-bold">Désolé nous sommes en Maintenance</p>
                <p className="text-light">Le service sera bientôt de retour</p>
            </div>
        </div>
    );
};

export default Maintenance;



// WEBPACK FOOTER //
// ./src/components/App/Maintenance.js